import { CloseOutlined, CopyOutlined, FilePdfTwoTone } from "@ant-design/icons";
import { Avatar, Badge, Tooltip } from "antd";
import React from "react";
import { Button, Col, Modal, Row } from "reactstrap";
import toast from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import "../utils/detail.css";
import CardImageItem from "../../../../common/image/cardImage";
import defaultLogo from "../../../../assets/images/noImage.avif";
import OpenSecurePdf from "../../../../common/file/openFile";
import { countryInfo } from "../../../developer/component/PaymentMethodSelector";

const DetailBusiness = ({ modal, setModal, toggle, selectedDeveloper, currentuser }) => {
  const { businessName, sectorName, type, description, logo, businessRegistry, apiKey, apiToken, documents = []} = selectedDeveloper || {};
  const countryPaymentMethods = Array.isArray(selectedDeveloper?.countryPaymentMethods) ? selectedDeveloper.countryPaymentMethods : [];
  const { name, country, paymentMethod, currency, prefixCode } = countryPaymentMethods || [];
  const handleCopy = (key) => {
    if (!key) {
      toast.info("Désolé pas de clé à copier", { autoClose: 3000 });
    } else {
      navigator.clipboard.writeText(key);
      toast.success("Clé copiée avec succès 🎯", { autoClose: 2000 });
    }
  };
  const getCountryFlag = (code) => {
    const codePoints = code
      .toUpperCase()
      .split("")
      .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
  }; 

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      onCancel={toggle}
      centered
      backdrop="static"
      style={{ maxWidth: "900px" }}
    >
      <div className="modal-content-custom">
        <div className="modal-header-custom">
          <h1 className="title-detail-modal">Détail de mon business {businessName}</h1>
          <CloseOutlined className="close-btn" onClick={() => setModal(false)}/>
        </div>
        <Row>
          <div className="detail-div">
            <Row>
              <Col lg={2} className="logo-container mt-2 mb-4">
                <Avatar size={80}>
                  <CardImageItem fileName={logo} token={currentuser?.token} />
                </Avatar>
              </Col>

              <Col lg={12}>
                <h5 className="title">Description</h5>
                <p className="business-description">
                  {description || "Pas de description disponible pour cet business"}
                </p>
              </Col>
            </Row>

            <div>
              <h5 className="title">Informations du business</h5>
              <table className="recap-table">
                <thead>
                  <tr>
                    <th>Nom de l’entreprise</th>
                    <th>Secteur</th>
                    <th>Type</th>
                    <th>Pays</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{businessName || "-"}</td>
                    <td>{sectorName || "-"}</td>
                    <td>{type || "-"}</td>
                    <td>{selectedDeveloper?.country || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>

          <hr />

          <div className="detail-div mb-4">
            <h5 className="title">Méthodes de paiement </h5>
            {countryPaymentMethods.length > 0 ? (
              <table className="recap-table">
                <thead>
                  <tr>
                    <th>Pays</th>
                    <th>Code</th>
                    <th>Nom</th>
                    <th>Devise</th>
                    <th>Préfixe</th>
                  </tr>
                </thead>
                <tbody>
                  {countryPaymentMethods.flatMap((block) =>
                    block.paymentMethods?.map((method, i) => (
                      <tr key={`${block.country}-${i}`}>
                      <td>
                        {countryInfo[block.country]?.flag && (
                          <img
                            src={countryInfo[block.country].flag}
                            alt={countryInfo[block.country].name}
                            style={{ width: "20px", marginRight: "6px", verticalAlign: "middle" }}
                          />
                        )}
                        {countryInfo[block.country]?.name || block.country}
                      </td>
                        <td>{block.country || "-"}</td>
                        <td>{method.name || "-"}</td>
                        <td>{method.currency || "-"}</td>
                        <td>{method.prefixCode || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            ) : (
              <Row>
                <Col lg={12}>Aucune méthode de paiement disponible</Col>
              </Row>
            )}
          </div>

          <hr />
          <div className="detail-div">
          <h5 className="title">Documents requis</h5>
            <Row className="document-list mb-4">
              {businessRegistry ? (
                <Col lg={12}>
                  <div className="document-card">
                    <p className="document-title">Registre du commerce</p>
                    <FilePdfTwoTone twoToneColor="red" style={{ fontSize: '48px', marginBottom: '10px' }} />
                    <Button
                      className="view-btn"
                      onClick={() => OpenSecurePdf(businessRegistry, currentuser?.token)}
                    >
                      Voir
                    </Button>
                  </div>
                </Col>
              ) : (
                <div className="document-header">
                  <p>Aucun document disponible</p>
                    <Button className="later-btn">Renseigner maintenant</Button>
                </div>
              )}
            </Row>

          </div>

          <hr />

          <div className="detail-div">
            <h5 className="title">Clés API</h5>
            <Row>
              <Col lg={12} className="mb-2">
                <label>API Key</label>
                <div className="api-key-container">
                  <input
                    type="text"
                    className="api-key-input"
                    value={apiKey || "-"}
                    readOnly
                  />
                  <Tooltip title="Copier">
                    <Button
                      className="copy-btn"
                      onClick={() => handleCopy(apiKey)}
                    >
                      <CopyOutlined />
                      Copier
                    </Button>
                  </Tooltip>
                </div>
              </Col>
              <Col lg={12} className="mb-4">
                <label>API Token</label>
                <div className="api-key-container">
                  <input type="text" className="api-key-input" value={apiToken || "-"} readOnly />
                  <Tooltip title="Copier">
                    <Button
                      className="copy-btn"
                      onClick={() => handleCopy(apiToken)}
                    >
                      <CopyOutlined />
                      Copier
                    </Button>
                  </Tooltip>
                </div>
              </Col>
            </Row>
          </div>
        </Row>
      </div>
    </Modal>
  );
};

export default DetailBusiness;
